import ArrowDownIcon from "@/components/icons/arrow-down"

interface DownloadReceiptProps {
  shortId: string;
  paymentId: string;
}

export default function DownloadReceiptLink({
  shortId,
  paymentId,
}: DownloadReceiptProps) {
  return (
    <a
      href={`/api/v1/payment-pages/${shortId}/payments/${paymentId}/receipt`}
      className="flex flex-row gap-2 items-center text-blue-500 font-semibold text-sm"
    >
      <ArrowDownIcon size={20} />
      Download receipt
    </a>
  )
}
